import { defineMessages } from 'react-intl';

export const jiraExtensionMessages: {
	extensionDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionDescriptionIssueTerminologyRefreshM4: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionTitleIssueTerminologyRefreshM4: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionTitleWorkItem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	// Remove when cleaning up platform_editor_slash_command
	extensionTitle: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.title',
		defaultMessage: 'Create Jira issue',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	// Remove when cleaning up platform_editor_slash_command
	extensionTitleIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4',
		defaultMessage: 'Create Jira work item',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	extensionTitleWorkItem: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.title-work-item',
		defaultMessage: 'Jira work item',
		description:
			'Title displayed to the user on option in the Create section of the slash command menu for creating a Jira work item',
	},
	extensionDescription: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.description',
		defaultMessage: 'Create an issue inline and insert the issue as a link',
		description: 'Message that elaborates on the title for the quick insert option',
	},
	extensionDescriptionIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4',
		defaultMessage: 'Create and link a Jira work item',
		description: 'Message that elaborates on the title for the quick insert option',
	},
});
